"use client";
import "./index.es73.js";
import "react";
import "./index.es74.js";
import "./index.es75.js";
import "./index.es76.js";
import "./index.es77.js";
import "./index.es78.js";
import "./index.es79.js";
import r from "./index.es141.js";
r.fieldset`
  display: flex;
  & > * {
    margin-right: 0.5rem;
    margin-top: 0.25rem;
    margin-bottom: 0.75rem;
  }

  legend {
    border: none;
  }
`;
//# sourceMappingURL=index.es90.js.map
